import { buildURLParams } from '@/lib/transform'

import { useFetch } from './useFetch'

export type Category = {
  parentId: number
  name: string
  id: number
  hasChildren: boolean
}

export const CATEGORY_ENDPOINT = '/api/proxy/catalog/pvt/admin/category'

interface CategoryParams {
  parentId?: number
  categoryName?: string
  [key: string]: string | number | undefined
}

export const useCategory = <Type extends Category>(
  categoryParams: CategoryParams = {},
  isActive = true
) =>
  useFetch<Type[]>(
    ({ account }) =>
      `${CATEGORY_ENDPOINT}?an=${account}&${buildURLParams(categoryParams)}`,
    { isActive }
  )
